import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export const ProfileError = () => (
  <div className="p-6">
    <Typography.LabelSm>{t("something_went_wrong")}</Typography.LabelSm>
  </div>
);
